export default __webpack_public_path__ + "static/media/eliseoImperial.9e531c51.jpg";